<script>
import FundClassification from "./../fund-classification";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    FundClassification,
  },
  data() {
    return {
      submitted: false,
      classifications: [],
      classificationOptions: [],
      newClassification: {
        id: 0,
        className: null,
        shortName: null,
        isDebit: false,
        sortOrder: 0,
        trialBalance: false,
        balanceSheet: false,
        incomeStatement: false,
        equity: false,
        cashFlow: false,
        others: false,
      },
    };
  },
  methods: {
    getAccountClassifications() {
      this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", true);
      this.$store
        .dispatch("accountclass/getAllAccountClassifications")
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.classificationOptions = response.data.map((item) => ({
            value: item.id,
            text: item.className,
          }));
          this.classificationOptions.unshift({
            value: null,
            text: "Select classification...",
            disabled: true,
          });
          this.classifications = response.data
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map((items) => ({
              ...items,
              subClasses: [],
            }));
          if (this.classifications.length > 0) {
            /** class function */
            this.getSubClasses();
          } else {
            this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", false);
          }
        })
        .catch((error) => {
          this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", false);
          this.showToast(
            "An error occured while fetching account classifications",
            "error"
          );
        });
    },
    getSubClasses() {
      if (this.classifications.length === 0) {
        this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", false);
        return false;
      }
      this.classifications.forEach((item, index) => {
        this.$store
          .dispatch("fundclassification/GetFundClassificationByAccountClassId", item.id)
          .then((response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            this.classifications[index].subClasses = response.data.map((item) => ({
              ...item,
              accountGroups: [],
              rotateChevy: false,
              isLoading: false,
            }));
            this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", false);
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("accountclass/SET_IS_ACCOUNT_CLASS_LOADING", false);
            this.showToast("An error occured while fetching sub classes", "error");
          });
      });
    },
    printAccounts() {
      this.$emit("printAccounts");
    },
    editItem(record) {
      this.newClassification = JSON.parse(JSON.stringify(record));
      this.$bvModal.show("edit-classification-modal");
    },
    saveChanges() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.newClassification.$invalid) {
        return;
      } else {
        this.$bvModal.hide("edit-classification-modal");
        this.pageLoader(true);
        this.$store
          .dispatch("accountclass/updateAccountClassification", {
            id: this.newClassification.id,
            data: this.newClassification,
          })
          .then((response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            this.showToast("Account classification saved successfully", "success");
            this.getAccountClassifications();
            this.pageLoader(false);
          })
          .catch((error) => {
            console.log(error);
            this.pageLoader(false);
            this.showToast(
              "An error occured while saving account classification",
              "error"
            );
          });
      }
    },
  },
  validations: {
    newClassification: {
      className: { required },
    },
  },
  created() {
    this.getAccountClassifications();
  },
};
</script>

<template>
  <div>
    <!-- MODALS -->
    <b-modal
      id="edit-classification-modal"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      title="Edit Classification"
    >
      <b-form-group label="Classification name" class="mb-2" label-class="text-info">
        <b-form-input
          class="form-control"
          type="text"
          v-model="newClassification.className"
          placeholder="Enter classification name..."
          :class="{
            'is-invalid': submitted && $v.newClassification.className.$error,
          }"
        >
          <div
            v-if="submitted && $v.newClassification.className.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.newClassification.className.required"
              >This value is required.</span
            >
          </div>
        </b-form-input>
      </b-form-group>
      <b-form-group label="Short name" class="mb-2" label-class="text-info">
        <b-form-input
          class="form-control"
          type="text"
          v-model="newClassification.shortName"
          placeholder="Enter short name..."
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Short name" class="mb-2" label-class="text-info">
        <b-form-input
          class="form-control"
          type="number"
          v-model="newClassification.sortOrder"
        ></b-form-input>
      </b-form-group>
      <div class="mt-3">
        <div class="row">
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="isDebit"
                v-model="newClassification.isDebit"
              />
              <label class="form-check-label" for="isDebit"> For Debit </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="trialBalance"
                v-model="newClassification.trialBalance"
              />
              <label class="form-check-label" for="trialBalance">
                For Trial Balance
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="balanceSheet"
                v-model="newClassification.balanceSheet"
              />
              <label class="form-check-label" for="balanceSheet">
                For Balance Sheet
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="incomeStatement"
                v-model="newClassification.incomeStatement"
              />
              <label class="form-check-label" for="incomeStatement">
                For Income Statement
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="equity"
                v-model="newClassification.equity"
              />
              <label class="form-check-label" for="equity"> For Equity </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="cashFlow"
                v-model="newClassification.cashFlow"
              />
              <label class="form-check-label" for="cashFlow"> For Cash Flow </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="others"
                v-model="newClassification.others"
              />
              <label class="form-check-label" for="others"> For Others </label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pb-0">
        <b-button size="sm" @click="saveChanges" variant="warning">Save Changes</b-button>
        <b-button
          variant="link"
          @click="$bvModal.hide('edit-classification-modal')"
          size="sm"
          >Close</b-button
        >
      </div>
    </b-modal>
    <!-- MODALS -->
    <h4 class="text-light mb-0" v-if="$store.state.accountclass.isAccountClassLoading">
      <i class="bx bx-hourglass bx-spin me-2"></i> Fetching account classifications...
    </h4>
    <div class="accordion w-100" v-else role="tablist">
      <div class="text-right mb-2">
        <button class="btn btn-purple" @click="printAccounts"><i class="bx bx-printer me-1"></i>Generate Chart of Accounts</button>
      </div>
      <b-card
        no-body
        class="mb-0"
        v-for="classification in classifications"
        :key="classification.id"
      >
        <b-card-header header-tag="header" class="p-0">
          <b-list-group-item
            button
            action
            tabindex="0"
            v-b-toggle="`accordion-${classification.id}`"
            class="list-group-item list-group-item-action d-flex justify-content-between"
          >
            <div>
              <i class="far fa-list-alt font-size-15 align-middle me-2 text-yellow"></i>
              <span class="font-size-16 text-light align-middle">{{
                classification.className
              }}</span>
            </div>
            <div role="button" @click="editItem(classification)">
              <i class="bx bx-pencil font-size-16 align-middle text-warning me-2"></i>
              <small class="align-middle font-size-6">UPDATE</small>
            </div>
          </b-list-group-item>
        </b-card-header>
        <b-collapse :id="`accordion-${classification.id}`" accordion role="tabpanel">
          <FundClassification
            :subClasses="classification.subClasses"
            :classifications="classificationOptions"
            :selectedClassification="classification"
            @printAccounts="printAccounts"
          />
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
